import { styled } from 'css-literal-loader/styled';
import React from 'react';
import mapProps from 'recompose/mapProps';

import FormattedPrice from './FormattedPrice';

const Total = mapProps(({ value, ...props }) => ({
  ...props,
  children: !value ? '$—' : <FormattedPrice value={value} />,
}))(styled('span', null, "Total", require("./Total-Total.module.scss"), "total", "total"));

export default Total;
